module.exports = __webpack_public_path__ + "img/back_m3.03453a9d.png";